import { DateTime } from "luxon";

import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";
import { ALARM_TYPES } from "@/lib/drivers/insulet/IBFRecords/IBF_ALARM_LOGS";

export type IBFAlarm = {
  date: DateTime;
  alarmType: number;
  alarmName: string;
  fileNumber: number;
  lineNumber: number;
  errorCode: number;
  stopsDelivery: boolean;
};

export const IBF_ALARM = {
  value: 0x0400,
  name: "IBF_ALARM",
  size: 16,
  parse: (record): IBFAlarm => {
    const date = record.nextDateTime();
    record.skip(1);
    const alarmType = record.nextUInt16LE();
    const alarm = Object.values(ALARM_TYPES).find(alarm => alarm.value === alarmType);
    const fileNumber = record.nextUInt16LE();
    const lineNumber = record.nextUInt16LE();
    const errorCode = record.nextUInt16LE();
    return {
      date,
      alarmType,
      alarmName: alarm?.name ?? "Unknown",
      fileNumber,
      lineNumber,
      errorCode,
      stopsDelivery: !!alarm?.stopsDelivery,
    };
  },
} as const satisfies IBFHistoryRecordDefinition<IBFAlarm>;
